import { feature } from 'topojson-client';

export function fetchJSON(url) {
  return fetch(url).then(res => res.json());
};

export async function fetchTopoJSON(url) {
  const topoData = await fetchJSON(url);
  const objectKey = Object.keys(topoData.objects)[0];
  const geojson = feature(topoData, topoData.objects[objectKey]);
  return geojson;
}

export async function fetchImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.src = url;
  });
}

export default {
  fetchJSON
};
